<template>
  <div>
    <div>
      <el-form :inline="true" :model="searchFormData">
        <el-form-item>
          <el-input v-model="searchFormData.name" placeholder="输入名称搜索"></el-input>
        </el-form-item>
        <el-form-item label="项目选择">
          <el-select
              v-model="searchFormData.project_id" placeholder="全部"
                clearable
                filterable
                style="width:100%"
              >
              <el-option
                v-for="item in projectDataList"
                :key="item.project_id"
                :label="item.name"
                :value="item.project_id"
              />
          </el-select>
        </el-form-item>

        <el-form-item label="职位选择">
          <el-select
              v-model="searchFormData.job_id" placeholder="全部"
                clearable
                filterable
                style="width:100%"
              >
              <el-option
                v-for="item in jobDataList"
                :key="item.job_id"
                :label="item.title"
                :value="item.job_id"
              />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="abc">
      <div class="abc_left">
        <span>结算状态</span>
        <el-radio-group v-model="searchFormData.relation_status" @change="changeStatus">
          <el-radio label="">全部</el-radio>
          <el-radio :label="15">待结算</el-radio>
          <el-radio :label="16">已结算</el-radio>
          <el-radio :label="17">待评价</el-radio>
          <el-radio :label="18">已评价</el-radio>
          <el-radio :label="19">已双评</el-radio>
          <!--15结算中，16已结算，17已评价企业，18已评价主管，19已双评-->
        </el-radio-group>
      </div>
      <div class="abc_right">
      </div>
    </div>
    <div class="middle">
      <RecruitItem  v-for="(item,index) in pageProps.records" 
          :key="index" 
          :obj="item" 
          :type="4"
          :batch="false"
        >   
        </RecruitItem>
    </div>
    <div class="bottom">
      <div>
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" 
        :total="pageProps.total" :page-size="pageProps.pageSize" 
        :current-page="pageProps.pageNum" 
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange" />
      </div>
    </div>
  </div>

</template>

<script>
import RecruitItem from './components/recruit-item.vue'
import { projectList} from "@/api/director/project/index.js";
import { jobList} from "@/api/director/job/index.js";
//import { recruitList,jobList,projectList} from "@/api/director/work/recruit/index";
export default {
  components: {
    RecruitItem
  },
   data(){
    return {
      activeName: 'four',
      pageProps: {
        records: [],
        total: 0,
        pageNum: 1,
        pageSize: 6,
      },

      searchFormData: {
        type:4,//1报名审核，2地址审核，3签写合同，4结算评价
        name: "",
        project_id: "",
        job_id:"",
        relation_status: "", //0待邀，1已邀，2淘汰，3备选，6通————-
        page: 0,
        limit: 0,
      },

      projectDataList:[],
      jobDataList:[],
    }
   },

   mounted () {
    this.initProjectList();
    this.initJobList();
    this.fetchData();
  },

   methods:{
    search(){
      this.fetchData();
    },

    changeStatus(){
      this.fetchData();
    },

    refreshData(){
      this.fetchData();

    },

    changeStatus(){
      this.fetchData();
    },
    fetchData () {
      var that = this;
      that.searchFormData.page = that.pageProps.pageNum;
      that.searchFormData.limit = that.pageProps.pageSize;

      recruitList(that.searchFormData).then((response) => {
        console.log(response);
        that.pageProps.records = response.data.data;
        that.pageProps.total = response.data.total;
      });
    },

    //项目列表
    initProjectList(){
      var that = this;
      projectList({}).then((response) => {
        console.log('projectList',response);
        that.projectDataList = response.data;
      });
      
    },
    

    //职位列表
    initJobList(){
      var that = this;
      jobList({}).then((response) => {
        console.log('jobList',response);
        that.jobDataList = response.data;
      });
      
    },
    

    // 当前页变更
    handleCurrentChange (num) {
      this.pageProps.pageNum = num;
      this.fetchData();
    },

    // 每页显示页面数变更
    handleSizeChange (size) {
      this.pageProps.pageSize = size;
      this.fetchData();
    },
   }

}
</script>

<style lang="scss" scoped>
.abc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #999999;
  font-size: 14px;
  .abc_left {
    span {
      margin-right: 20px;
    }
  }
}
.middle {
  margin: 10px auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  min-height: 400px;

}
.bottom {
  width: 300px;
  margin-left: 336px;
}
</style>